module.exports = __webpack_public_path__ + "img/box_delivery.1fce5415.png";